import CompanionMaterialItem from "../models/CompanionMaterialItem";
import CompanionMaterialDetailItem from "../models/CompanionMaterialDetailItem";
import Item from "../models/Item";

class CompanionMaterialBuilder {
    static build(item: Item) {
        const companionMaterialInfo: Element | null = new DOMParser().parseFromString(item.qti, "text/xml").querySelector("qti-companion-materials-info");
        if (companionMaterialInfo) {
            for (let i = 0; i < companionMaterialInfo.children.length; i++) {
                item.addCompanionMaterialItem(CompanionMaterialBuilder.createCompanionMaterialItem(companionMaterialInfo.children[i]));
            }
        }
    }

    private static createCompanionMaterialItem(companionElement: Element): CompanionMaterialItem {
        const companionMaterialItem: CompanionMaterialItem = new CompanionMaterialItem(companionElement.tagName);
        for (let i = 0; i < companionElement.children.length; i++) {
            const companionMaterialDetailItem: CompanionMaterialDetailItem = this.createCompanionMaterialDetailItem(companionElement.children[i]);
            companionMaterialItem.addCompanionMaterialDetailItem(companionMaterialDetailItem);

            this.addCompanionMaterialDetailItem(companionElement.children[i], companionMaterialDetailItem);
        }

        return companionMaterialItem;
    }

    private static addCompanionMaterialDetailItem(element: Element, companionMaterialDetailItem: CompanionMaterialDetailItem): void {
        for (let i = 0; i < element.children.length; i++) {
            const newCompanionMaterialDetailItem: CompanionMaterialDetailItem = this.createCompanionMaterialDetailItem(element.children[i])
            companionMaterialDetailItem.addCompanionMaterialDetailItem(newCompanionMaterialDetailItem)

            this.addCompanionMaterialDetailItem(element.children[i], newCompanionMaterialDetailItem);
        }
    }

    private static createCompanionMaterialDetailItem(element: Element): CompanionMaterialDetailItem {
        const companionMaterialDetailItem: CompanionMaterialDetailItem = new CompanionMaterialDetailItem(element.tagName, element.innerHTML);
        for (let i = 0; i < element.attributes.length; i++) {
            companionMaterialDetailItem.addAttribute(element.attributes[i].name, element.attributes[i].value);
        }

        return companionMaterialDetailItem;
    }
}

export default CompanionMaterialBuilder;
